import { PureComponent } from 'react';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { FormControl, IconButton, InputLabel, OutlinedInput } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';

import InputFooter from 'components/UI/atoms/InputFooter/InputFooter';

export type Props = {
  fullWidth?: boolean;
  label: string;
  name: string;
  helperText?: string;
  error?: string;
};

type State = {
  showPassword: boolean;
};

class InputPassword extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  toggleShowPassword = () => this.setState(prev => ({ showPassword: !prev.showPassword }));

  render() {
    const { label, error, fullWidth = true, helperText, ...field } = this.props;
    const { showPassword } = this.state;
    return (
      <FormControl error={!!error} fullWidth={fullWidth}>
        {label && <InputLabel htmlFor={`password_input_${label}`}>{label}</InputLabel>}
        <OutlinedInput
          color='secondary'
          endAdornment={
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle password visibility'
                color='secondary'
                edge='end'
                tabIndex={-1}
                onClick={this.toggleShowPassword}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          id={`password_input_${label}`}
          inputProps={{ 'data-testid': `${field.name}_input` }}
          type={showPassword ? 'text' : 'password'}
          {...field}
        />
        <InputFooter error={error} helperText={helperText} name={field.name} />
      </FormControl>
    );
  }
}

export default InputPassword;
